import { cn } from '@mint-lib/tw-utils';

import { Label } from '../../lib/label.jsx';
import { ProgressIndicator, ProgressRoot } from '../../lib/progress.jsx';
import { CircularIndicator } from './CircularIndicator.jsx';

type ProgressCircularProps = {
  withLabel?: boolean;
  size?: 'large' | 'small' | 'xsmall';
  color?: 'primary' | 'secondary' | 'warning' | 'ai';
  determinate?: boolean;
  indicatorClassNames?: string;
  trackClassNames?: string;
} & React.ComponentProps<typeof ProgressRoot>;

function ProgressCircular({
  withLabel = false,
  color = 'primary',
  size = 'large',
  determinate = false,
  className,
  indicatorClassNames,
  trackClassNames,
  ...props
}: ProgressCircularProps) {
  return (
    <ProgressRoot
      data-slot="progress-root"
      data-size={size}
      data-color={color}
      className={cn(
        'group/progress flex items-center justify-center gap-2 data-[size=large]:relative data-[size=large]:size-10',
        className,
      )}
      {...props}
    >
      <ProgressIndicator asChild>
        <CircularIndicator
          value={props.value ?? 0}
          size={size}
          color={color}
          determinate={determinate}
          indicatorClassNames={indicatorClassNames}
          trackClassNames={trackClassNames}
        />
      </ProgressIndicator>
      {withLabel && determinate && (
        <Label
          variant="caption1"
          color="secondary"
          className="group-data-[size=large]/progress:absolute"
        >
          {props.value}%
        </Label>
      )}
    </ProgressRoot>
  );
}

export default ProgressCircular;
